import Box from '@mui/material/Box';

import { EntityType } from '@/core/graphql/generated/types';

import { AddressSection } from '../../Sections/AddressSection/AddressSection';
import { AffiliationsSection } from '../../Sections/AffiliationsSections/AffiliationsSections';
import { ContactSection } from '../../Sections/ContactSection/ContactSection';
import { HcpDemographicsSection } from '../../Sections/HcpSections/HcpDemographicsSection/HcpDemographicsSection';
import { HcpIdsSection } from '../../Sections/HcpSections/HcpIdsSection/HcpIdsSection';
import { HcpLicensesSection } from '../../Sections/HcpSections/HcpLicensesSection/HcpLicensesSection';
import { HcpNameSection } from '../../Sections/HcpSections/HcpNameSection/HcpNameSection';
import { HcpProfessionalSection } from '../../Sections/HcpSections/HcpProfessionalSection/HcpProfessionalSection';

export const HcpDcrModalContent = () => {
	return (
		<Box display='flex' flexDirection='column' gap={3}>
			<HcpNameSection />
			<HcpProfessionalSection />
			<HcpIdsSection />
			<HcpDemographicsSection />
			<ContactSection />
			<AffiliationsSection entityType={EntityType.Hcp} />
			<AddressSection />
			<HcpLicensesSection />
		</Box>
	);
};
